module.exports = __webpack_public_path__ + "assets/gye-alt.2414aa46.svg";